<template lang="pug">
div
  .wuwow-card
    .wuwow-card-body
      b-container
        b-row
          .titleBox
            img(align='left' src='https://cdn2.wuwow.tw/pictures/mgms/title-sun.png' alt='太陽' title='太陽')
            //- span.titleText.text-center &#x300C;WU&#x670B;&#x5F15;&#x4F34;&#xFF0C;&#x505A;&#x4F19;&#x4F86;&#x300D;&#x6D3B;&#x52D5;&#x6CE8;&#x610F;&#x4E8B;&#x9805;
            span.titleText.text-center.font-weight-bold 「WU朋引伴，做伙來」活動規則
            img(align='right' src='https://cdn2.wuwow.tw/pictures/mgms/title-cloud.png' alt='雲' title='雲')
        b-row
          b-col(cols="12")
            //- 2024-01-08 00:00:00 後下架
            .anniversary2023Active(v-if="!deadlinesAfter && !vipRecommendInfo.is_buy_google")
              h2.anniversary2023Active-title.text-center
                img(src="@/assets/mgm/anniversary_2023-title.svg" alt="周年慶")
              .anniversary2023Active-table
                ul.anniversary2023Active-tableHader
                  li
                  li 週年慶加碼活動
                ul.anniversary2023Active-day
                  li 活動日期
                  li 2023.12.4 ~ 2024.1.7
                ul.anniversary2023Active-target
                  li 參加對象
                  li 不限在期學員，凡是購買過 WUWOW/ WUWOW JUNIOR的學員都可加入推薦。
                ul.anniversary2023Active-machine
                  li 獎勵機制
                  li
                    p 推薦獎
                    p
                      | 幸運抽獎許願池推薦符合資格好友，
                      br
                      | 再領
                      span.text-scroll LINE POINTS 200點
                    p 成交獎
                    p
                      span 獎金
                      | 依購買方案類型，獲得不同的推薦獎金或課程堂數。
                      br
                      | 推薦人數無上限，單次最高可獲得推薦獎金
                      br
                      | 從「 NT$ 6,000 」調漲至「
                      span.text-scroll NT$ 6,500
                      | 」。
                      br
                      | 詳細內容，歡迎於
                      span.text-scroll 推薦方法
                      | 頁面查看
                      img(src="https://wuwow-store.s3.ap-southeast-1.amazonaws.com/pictures/mgms/money.svg", alt="money")
            .anniversary2023Active(v-if="!deadlinesAfter && vipRecommendInfo.is_buy_google")
              h2.anniversary2023Active-title.text-center
                img(src="@/assets/mgm/anniversary_2023-title.svg" alt="周年慶")
              .anniversary2023Active-table
                ul.anniversary2023Active-tableHader.google-mgm
                  li
                  li Google限定活動
                  li 週年慶加碼活動
                ul.anniversary2023Active-day
                  li.d-none.d-lg-block 活動日期
                  li
                    span.d-lg-none 活動日期
                    | 2023.12.4 ~ 2024.1.7
                ul.anniversary2023Active-target.google-mgm
                  li 參加對象
                  li
                    | 不限在期學員，凡是購買過 WUWOW/ WUWOW JUNIOR
                    span.text-scroll Google 方案
                    | 學員都可加入推薦。
                  li 不限在期學員，凡是購買過 WUWOW/ WUWOW JUNIOR的學員都可加入推薦。
                ul.anniversary2023Active-machine.google-mgm
                  li 獎勵機制
                  li
                    p 推薦獎
                    p
                     | 幸運抽獎許願池，維持不變
                    p 成交獎
                    .award-Details
                      p
                        span 獎品 累進制
                        br
                        | 推薦 2 位加入，獲得新NT$2,000
                        br
                        | 推薦 3 位加入，獲得新NT$4,500
                        br
                        | 推薦 5 位加入，獲得新NT$10,000
                        br
                        | 推薦 10 位加入，獲得新NT$30,000
                        br
                        | 推薦 20 位加入，獲得新
                        span.text-scroll NT$100,000
                        br
                        br
                        | 詳細內容，歡迎於
                        span.text-scroll(@click="scrollTo('.scollSeven')") 推薦方法
                        | 頁面查看
                      p
                        span 獎金
                        | 依購買方案類型，獲得不同的推薦獎金或課程堂數。
                        br
                        | 推薦人數無上限，單次最高可獲得推薦獎金
                        br
                        | 從「 NT$ 6,000 」調漲至「
                        span.text-scroll NT$ 6,500
                        | 」。
                        br
                        | 詳細內容，歡迎於
                        span.text-scroll 推薦方法
                        | 頁面查看
                        img(src="https://wuwow-store.s3.ap-southeast-1.amazonaws.com/pictures/mgms/money.svg", alt="money")
          b-col(cols="12")
            .activeRule
              h2.activeRule-title.original(:class="{close: !deadlinesAfter }") 最新活動調整
              p.activeRule-subTitle.original(:class="{close: !deadlinesAfter }")  自2023/7/6 起制度更新，推薦成交獎品由人數累進獎品制度，改為每一次成交都有推薦獎金。
              h3.activeRule-title 新舊制度比較
              .activeRule-form
                ul.activeRule-formHeard
                  li
                  li 舊制度
                  li 新制度
                ul.activeRule-day
                  li 活動日期
                  li
                    span.d-lg-none 活動日期
                    br.d-lg-none
                    | 2020.4.17-2023.7.5
                  li
                    span.d-lg-none 活動日期
                    br.d-lg-none
                    | 2023.7.6 起
                ul.activeRule-target
                  li 參加對象
                  li 不限在期學員，凡是購買過 WUWOW/ WUWOW JUNIOR的學員都可加入推薦。
                .activeRule-machine
                  p 獎勵機制
                  ul
                    li 推薦獎
                    li 幸運抽獎許願池，維持不變
                    li 成交獎
                    li
                      p
                        | 獎品 累進制
                        br
                        br
                        | 推薦 1 位加入，獲得「Google Nest
                        br
                        | Mini 智慧音箱」
                        br
                        br
                        | 推薦 3 位加入，獲得「Airpods」
                        br
                        br
                        | 推薦 5 位加入，獲得「iPad」
                        br
                        br
                        | 推薦 6 位 (含)以上，每推薦一人可獲得
                        br
                        |「台幣 NT$ 1,500」
                      p
                        span.font-weight-bold 獎金
                        br
                        br
                        | 依購買方案類型，獲得不同的推薦獎金或課程堂數。
                        br
                        | 推薦人數無上限，單次最高可獲得推薦獎金「
                        span.orange-color NT$ 6,000
                        | 」。
                        br
                        br
                        | 詳細內容，歡迎於「
                        span.orange-color 推薦方法
                        | 」頁面查看。
          b-col.mt-4
            ul.activeDescription
              li(class="mb-4")
                h3 一、活動目的：
                p 讓更多想要學習英文的人，一起加入 WUWOW / WUWOW JUNIOR 共學英文！
              li(class="mb-4")
                h3(class="mb-1") 二、活動參加資格：
                p.activeDescription-item(data-count="1." class="mb-1")
                  | 一日 WUWOW 人，終身 WUWOW 魂！
                  br
                  | 凡曾為 WUWOW / WUWOW JUNIOR 之合約開通之學員，不限合約是否在期，皆可參與「 WU 朋引伴，做伙來」親友推薦。
                p.activeDescription-item(data-count="2." class="mb-1")
                  | 2022.12.9 起活動參加資格變更，2022.12.9 前，僅限合約開通日起之「在期」學員參與活動；
                  br
                  | 2022.12.9 後，不限合約時間，只要曾經為 WUWOW / WUWOW JUNIOR 學員，皆符合推薦好友資格。但不回補追朔歷年「合約已到期」之學員所推薦的任何活動獎項資格。
                //- 2024-01-08 00:00:00 後下架
                p.activeDescription-item(data-count="3." class="mb-1" v-if="!deadlinesAfter")
                  | 2023.12.04~2024.01.07 週年慶加碼期間，學員推薦符合條件資格的人填寫名單
                  span.text-scroll.curpointer(@click="scrollTo('.scollFive')") (參考B項第5點)
                  | ，「推薦者」即可獲得 Line Points $200元
                  br
                  | 且若「被推薦者」購買指定方案課程，可得最高「加贈45堂(WUWOW) 或 加贈15堂(JR)」英文課程。
                  span.text-scroll.curpointer(@click="scrollTo('.scollSix')") (參考B項第6點)
                  | 呈上，推薦成功的「推薦者」還有機會獲得最高推薦獎金$6,500元。
                  span.text-scroll.curpointer(@click="scrollTo('.scollSix')") (參考B項第6點)
                //- 2024-01-08 00:00:00 後下架
                p.activeDescription-item(data-count="4." v-if="!deadlinesAfter")
                  | 該活動「推薦獎金」 LINE POINTS 將於 2024/1/31 進行信箱發放，記得確保會員資料的信箱為您的常用收件信箱，避免遺失 LINE POINTS 哦！(任何因資訊錯誤導致遺失 LINE POINTS 領取，皆不做補發)
                  br
                  | 該活動「成交獎金」領取相關時程，請注意推薦成交成功後的「通知信件」，繳回相關「獎金領據」等領獎流程，將可依序獲得獎金。
                //- 2024-01-08 00:00:00 後下架
                p.activeDescription-item(data-count="5." v-if="!deadlinesAfter")
                  | Google 企業專屬推薦活動：2023.12.04~2024.01.07 週年慶加碼期間，學員推薦符合條件資格的人填寫名單 (參考B項第5點) ，「推薦者」即可獲得 Line Points $200元，且若「被推薦者」購買指定方案課程，「推薦者」可得最高「$100,000」推薦成功獎金。 (參考B項第7點)。
              li(class="mb-4")
                h3(class="mb-3") 三、注意事項：
                h4(class="mb-2") A. 重要活動注意事項
                p.activeDescription-item(data-count="1.") 自 2023.7.6 起，成交獎由獎品制改為獎金制度，於該日之前推薦之名單若有成交，比照舊制獎勵處理。
                p.activeDescription-item(data-count="2.") 所有推薦、獎勵紀錄與發放，可於「我的推薦」中的「推薦紀錄」查看，若該名好友資訊填入有誤、無法聯繫、非本人、非經學員推薦、重複名單，則不予以發放抽獎券、且不計入推薦人數。
                p.activeDescription-item(data-count="3.") 被推薦人透過專屬連結完成預約體驗，即表示同意 WUWOW / WUWOW JUNIOR 可將其姓名(部分文字隱藏)、課程體驗日期、購買進度與否之資訊與推薦人知悉。
                p.activeDescription-item(data-count="4." class="mb-3") WUWOW 品牌方擁有本活動的最終解釋權，並有權隨時修改、變更、取消本活動。
                h4(class="mb-2") B. 推薦注意事項
                p.activeDescription-item(data-count="1.") 若同一名學員有大於兩人以上之推薦者，則獎項歸屬於首位推薦者。
                div.activeDescription-item(data-count="2.") 本活動僅認列含有推薦碼以及透過「WU朋引伴，做伙來」頁面填寫之資料，且亦不認列下方三種情形：
                  p.activeDescription-item(data-count="(1)")  填寫「WU朋引伴，做伙來」之前，被推薦人已曾經購買 WUWOW / WUWOW JUNIOR 課程方案
                  p.activeDescription-item(data-count="(2)") 填寫「WU朋引伴，做伙來」之前，被推薦人已與課程顧問正在溝通階段，則推薦不予計算。
                  p.activeDescription-item(data-count="(3)")  「WU朋引伴，做伙來」之後，被推薦人拒絕本次推薦，後續透過其他方式加入 WUWOW / WUWOW JUNIOR，則推薦不予計算。
                p.activeDescription-item(data-count="3.") 若 WUWOW / WUWOW JUNIOR 收到大量惡意灌水之推薦名單，經 WUWOW 品牌方判斷證實，將終止該學員「 WU 朋引伴 」推薦、獎項領取資格，並須就被推薦人以及 WUWOW 品牌方之相關損害負完全賠償責任。
                p.activeDescription-item(data-count="4.") WUWOW 品牌方將以信件聯繫每月抽將活動中獎學員、以及符合成功推薦獎勵資格之學員，與學員確認獎項寄送細項後，始予以頒發獎項。
                div.activeDescription-item.scollFive(data-count="5.")
                  span.font-weight-bolder(style="font-size: 16px;") 推薦獎
                  p.activeDescription-item(data-count="(1)") 推薦名單經 WUWOW / WUWOW JUNIOR 專員聯繫（約需6~7個工作天）完成確認後，始予以發放抽獎券，歡迎至個人推薦紀錄中查詢狀態。
                div.activeDescription-item.scollSix(data-count="6." class="mb-2")
                  span.font-weight-bolder(style="font-size: 16px;") 成交獎
                  p.activeDescription-item(data-count="(1)") 成交獎領取資格，需於被推薦人「合約起始日一個月」後始確認成交，確認完畢後 WUWOW / WUWOW JUNIOR 將發放推薦人與被推薦人之獎勵。
                  p.activeDescription-item(data-count="(2)")
                    | 被推薦人購買方案須為 WUWOW / WUWOW JUNIOR 「一般課程」方案。
                    br
                    | 若是購買：每日一堂方案、企業方案（例：Google、克蘭詩）、團購方案... ...等，不予計算「推薦者」成功推薦人數（故成交獎資格皆無效）。
                  p.activeDescription-item(data-count="(3)") 被推薦人經推薦加入 WUWOW / WUWOW JUNIOR 後，若合約期滿再次購買方案，不予以重複計算推薦人之成功推薦人數，每位被推薦者僅可計算成功推薦人1次。
                  p.activeDescription-item(data-count="(4)") 分享/轉讓不視為購買，被推薦者獲現有學員之分享/轉讓，不予計算成功推薦人數。
                  p.activeDescription-item(data-count="(5)") 若被推薦人60日內經聯繫後結案，之後由其他管道再次進入聯繫環節，就算成交，亦不算被推薦名單，原有之推薦人無法領取成交獎勵。
                div.activeDescription-item.scollSeven(data-count="7." class="mb-3" v-if="!deadlinesAfter")
                  span.font-weight-bolder(style="font-size: 16px;") Google 企業專屬成交獎
                  p.activeDescription-item(data-count="(1)") 成交獎領取資格，需於被推薦人「合約起始日一個月」後始確認成交成功，確認完畢後 WUWOW / WUWOW JUNIOR 將發放推薦人之獎勵。
                  p.activeDescription-item(data-count="(2)") 被推薦人購買方案須為 WUWOW / WUWOW JUNIOR 「Google企業方案」課程。
                  p.activeDescription-item(data-count="(3)") 「被推薦者」者僅限首次購買「Google企業方案」課程，方為推薦成交成功；「推薦者」續約購買「Google企業方案」則可計推薦成交成功1次。
                  p.activeDescription-item(data-count="(4)") 分享/轉讓不視為購買，被推薦者獲現有學員之分享/轉讓，不予計算成功推薦人數。
                  p.activeDescription-item(data-count="(5)") 若被推薦人60日內經聯繫後結案，之後由其他管道再次進入聯繫環節，就算成交，亦不算被推薦名單，原有之推薦人無法領取成交獎勵。
                h4(class="mb-2") C. 活動獎項領取注意事項：
                div.activeDescription-item(data-count="1.")
                  span.font-weight-bolder(style="font-size: 16px;") 推薦獎
                  p.activeDescription-item(data-count="(1)") 每月抽獎活動之抽獎券於次月 6 號結算，確定抽獎獎項、每位學員抽獎券數量後，方抽出中獎學員名單。
                  p.activeDescription-item(data-count="(2)") 推薦獎項根據名單被推薦的時間決定，將如表訂獎項寄出，若有不可抗力因素須更換獎項 (如斷貨、天災等...)，WUWOW 品牌方將於通知後調整為等值之商品或延後寄送時間。
                div.activeDescription-item(data-count="2.")
                  span.font-weight-bolder(style="font-size: 16px;") 成交獎
                  p.activeDescription-item(data-count="(1)")
                    | 系統判定確立成交獎成立後，會以系統信件要求推薦者回傳「中獎領據」及「收款帳戶資
                    | 料」，待學員填寫完整、回傳，WUWOW 品牌方最遲將於收到完整資訊後的次月 16 號出款；倘若於「中獎領據」信寄出後 1 個月內，未將領據回傳，視同放棄領獎資格。
                  p.activeDescription-item(data-count="(2)") 推薦人之推薦獎金，可兌換等值課程堂數或延長會籍期限。
                  p.activeDescription-item(data-count="(3)") 推薦人與被推薦人經推薦加入 WUWOW / WUWOW JUNIOR 所獲得之免費堂數，與正式堂數擁有同等效力，可預訂 1 on 1家教、1 - 3人微班級、隨選隨上、百家書苑，不受任何額外限制。
          //- div(v-for='(part, index) in precautionGroup' :key='`precautionGroup_${index}`')
          //-   h5 {{part.title}}
          //-   p.precautionContent(v-html='part.content')
        b-row
          b-col(align='right' class="mt-5") WUWOW / WUWOW JUNIOR 行銷部
    b-img(src='https://cdn2.wuwow.tw/pictures/mgms/mgm-footer.png' fluid='' alt='頁尾圖片' title='頁尾圖片')
</template>

<script type="text/javascript">
import learnRuleModal from '@/components/wushare/learnRuleModal';
import moment from 'moment';
export default {
  name: 'Precautions',

  components: {
    learnRuleModal,
  },

  props: {
    vipRecommendInfo: { // 推薦方法
      type: Object,
      default: function() {
        return {};
      },
    },
  },

  data() {
    return {
      deadlines: '2024-02-08 00:00:00',
      deadlinesAfter: false,
      // precautionGroup: [{
      //   title: '活動資格：',
      //   content: '<p>(1) 一日 WUWOW 人，終身 WUWOW 魂！凡曾經為 WUWOW / WUWOW JUNIOR 之合約開通之學員，不限合約是否在期皆可參與「WU朋引伴，做伙來」推薦。<br><*活動參與資格變更：2022/12/9 前，僅限合約開通日起之「在期」學員參與活動；2022/12/9 後，不限合約時間，只要曾經為 WUWOW / WUWOW JUNIOR 學員，皆符合推薦好友資格。></p><p>(2) 2022/12/9號起更新活動資格，並且不回補追朔歷年「合約已到期」之學員所推薦的任何活動獎項資格。</p>',
      //   index: 1,
      // }, {
      //   title: '學員推薦相關注意事項：',
      //   content: '<p>(1) 學員推薦朋友之後，該筆名單資訊可於「推薦軌跡」下方之「被我推薦的好友」表單查看推薦紀錄，若該名好友資訊填入有誤、無法聯繫、非本人、非經學員推薦、重複名單，則不予以發放抽獎券、且不計入推薦人數。</p><p>(2) 推薦名單經 WUWOW / WUWOW JUNIOR 客服人員聯繫（約需6~7個工作天）完成確認後，始予以發放抽獎券。</p><p>(3) 被推薦人合約起始日一個月後始確認成交，確認完畢後WUWOW / WUWOW JUNIOR將發放推薦人與被推薦人之獎勵。</p><p>(4) 若同一名學員有大於兩人以上之推薦者，則抽獎券以及獎項歸屬於首位推薦者。</p><p>(5) 「被推薦人」使用方案必須為 WUWOW / WUWOW JUNIOR 一般課程方案。<br>若是購買：每日一堂方案、企業方案（例：Google、克蘭詩）、團購方案等，不予計算「推薦者」成功推薦人數（故抽獎券、成交獎資格皆無效）。</p><p>(6) 被推薦人經推薦加入 WUWOW / WUWOW JUNIOR 後，若合約期滿再次購買方案，不予以重複計算推薦人之成功推薦人數，每位被推薦者僅可計算成功推薦人1次。</p><p>(7) 若 WUWOW / WUWOW JUNIOR 收到大量惡意灌水之推薦名單，經 WUWOW 品牌方判斷證實，將終止該學員「 WU朋引伴，做伙來 」推薦資格，且未兌獎之抽獎券以及禮品皆失效，並須就被推薦人以及 WUWOW 品牌方之相關損害負完全賠償責任。</p><p>(8) 分享/轉讓不視為購買，被推薦者獲現有學員之分享/轉讓，不予計算成功推薦人數。</p><p>(9) 本活動僅認列含有推薦碼以及透過「WU朋引伴，做伙來」頁面填寫之資料，且亦不認列下方兩種情形：<ol><li>填寫「WU朋引伴，做伙來」之前，被推薦人已與課程顧問正在溝通階段，則推薦不予計算。</li><li>填寫「WU朋引伴，做伙來」之後，被推薦人拒絕本次推薦，後續透過其他方式加入WUWOW / WUWOW JUNIOR，則推薦不予計算。</li></ol></p>',
      //   index: 2,
      // }, {
      //   title: '活動禮物相關注意事項：',
      //   content: '<p>(1) 每月抽獎活動之抽獎券於次月 6 日結算，確定抽獎獎項、每位學員抽獎券數量、抽出中獎學員名單。</p><p>(2) 成功推薦之推薦獎勵將如表訂獎項寄出，若有不可抗力因素須更換獎項(如斷貨、天災等...)，WUWOW 品牌方將於通知後調整為等值之商品或延後寄送時間。</p><p>(3) WUWOW 品牌方將以信件聯繫每月抽將活動中獎學員、以及符合成功推薦獎勵資格之學員，與學員確認獎項寄送方式後，始予以寄出獎項。</p><p>(4) 被推薦人經推薦加入 WUWOW / WUWOW JUNIOR 所獲得之 30 / 10 堂免費堂數，與正式堂數擁有同等效力，可預訂1 on 1家教、1 - 3人微班級、隨選隨上、百家書苑，不受任何額外限制。</p><p>(5) 每日一堂方案不適用本活動之堂數獎勵。</p><p>(6) 系統判定確立中獎後，除了系統信件會要求您回傳收件資料，後續還會由品牌方另外寄出「中獎領據」給學員填寫，待學員填寫完整、回傳給WUWOW 品牌方後，方可領取獎品；倘若於「中獎領據」寄出後1個月內，尚未將領據回傳，視同放棄領獎資格。</p><p>(7) 第一重抽獎品項根據被推薦人填寫資料時間點決定，非以抽出時間決定(ex:第一重抽獎池6月獎品為手錶，7月獎品為刮鬍刀， 7/6日開獎6/30以前的參加者，故獎品為手錶。)</p>(8) 第二重成交獎根據被推薦人填寫資料時間點決定，非以成交時間決定(ex:成交獎6月獎品為手環，8月獎品為音響，6月份填名單的小美，在8月份才購買，推薦小美的大吳在 8月獲得的成交獎為6月份的手環。)',
      //   index: 3,
      // }, {
      //   title: '其他注意事項：',
      //   content: '<p>(1) 被推薦人透過專屬連結完成預約體驗，即表示同意 WUWOW / WUWOW JUNIOR 可將其姓名(部分文字隱藏)、課程體驗日期、購買進度與否之資訊與推薦人知悉。</p><p>(2) 本WU朋引伴作伙來活動獎勵方案自2020.04.17起始，本時間點以前之學員推薦名單恕不追溯計算。</p><p>(3) WUWOW 品牌方保留隨時修改、變更、取消本活動之權利。</p>',
      //   index: 4,
      // }],

    };
  },

  computed: {},

  watch: {},

  created() {
    this.deadlinesAfter = moment(new Date()).isAfter(this.deadlines);
  },

  methods: {
    scrollTo(domStr) {
      const gift = document.querySelector(domStr);
      gift.scrollIntoView({ behavior: 'smooth', block: 'center' });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/layout/layout.scss";

.activeRule {
  color: #333333;

  .activeRule-title {
    font-weight: 700;
    font-size: 21px;
    line-height: 120%;
    letter-spacing: 1.08px;
    margin-bottom: 20px;
    text-align: center;
  }

  .activeRule-subTitle {
    font-size: 16px;
    letter-spacing: 0.96px;
    margin-bottom: 40px;
  }
}

.activeRule-form {
  border: 1px solid #B9B9B9;
  border-radius: 4px;

  // overflow: hidden;
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }
}

.activeRule-formHeard {
  display: flex;
  width: 100%;
  color: #373737;
  font-weight: 700;

  li {
    text-align: center;
    padding: 10px 12px;
    font-size: 14px;
  }

  li:nth-child(1) {
    display: none;

    @include media-breakpoint-up(lg) {
      display: block;
      width: 120px;
      flex-shrink: 0;
      background: #E0DED2;
    }
  }

  li:nth-child(2) {
    flex-grow: 1;
    background: #E0DED2;
  }

  li:nth-child(3) {
    flex-grow: 1;
    background: #FFED80;
    position: relative;

    &::after {
      content: '';
      width: 58px;
      height: 51px;
      display: inline-block;
      position: absolute;
      top: -50%;
      right: 0;
      background: url('~@/assets/mgm/tips.svg') no-repeat center / contain;
    }
  }

  li:not(:last-child) {
    border-right: 1px solid #B9B9B9;
  }
}

.activeRule-day {
  display: flex;

  li {
    text-align: center;
    padding: 10px 12px;
    font-size: 14px;
    border-top: 1px solid #B9B9B9;
  }

  li:nth-child(1) {
    display: none;

    @include media-breakpoint-up(lg) {
      display: block;
      width: 120px;
      flex-shrink: 0;
    }
  }

  li:nth-child(2) {
    width: calc(100% - 120px / 2);
    background: #FAFAFA;
  }

  li:nth-child(3) {
    width: calc(100% - 120px / 2);
  }

  li:not(:last-child) {
    border-right: 1px solid #B9B9B9;
  }
}

.activeRule-target {
  display: flex;
  flex-wrap: wrap;

  li {
    text-align: center;
    padding: 10px 12px;
    font-size: 14px;
    border-top: 1px solid #B9B9B9;
  }

  li:nth-child(1) {
    width: 100%;
    background: #FFF9D9;

    @include media-breakpoint-up(lg) {
      background: #fff;
      flex-shrink: 0;
      width: 120px;
    }
  }

  li:nth-child(2) {
    width: 100%;

    @include media-breakpoint-up(lg) {
      width: calc(100% - 120px);
    }
  }

  li:not(:last-child) {
    @include media-breakpoint-up(lg) {
      border-right: 1px solid #B9B9B9;
    }
  }
}

.activeRule-machine {
  display: flex;
  flex-wrap: wrap;

  @include media-breakpoint-up(lg) {
    flex-wrap: nowrap;
  }

  >p {
    margin: 0;
    text-align: center;
    padding: 10px 12px;
    flex-shrink: 0;
    border-top: 1px solid #B9B9B9;
    width: 100%;
    background: #FFF9D9;

    @include media-breakpoint-up(lg) {
      width: 120px;
      background: #fff;
      border-right: 1px solid #B9B9B9;
    }
  }

  >ul {
    flex-grow: 1;
    border-top: 1px solid #B9B9B9;

    li {
      padding: 10px 12px;

      &:nth-child(1) {
        text-align: center;
        background: #F4F4F4;

        @include media-breakpoint-up(lg) {
          background: #FFF9D9;
        }
      }

      &:nth-child(2) {
        border-top: 1px solid #B9B9B9;
        text-align: center;
      }

      &:nth-child(3) {
        border-top: 1px solid #B9B9B9;
        text-align: center;
        background: #F4F4F4;

        @include media-breakpoint-up(lg) {
          background: #FFF9D9;
        }
      }

      &:last-child {
        padding: 0;
        display: flex;
      }

      &:last-child p:nth-child(1) {
        border-top: 1px solid #B9B9B9;
        background: #FAFAFA;
        color: #848484;
        width: 50%;
        padding: 20px 0;
        margin: 0;
        text-align: center;
        font-size: 14px;
      }

      &:last-child p:nth-child(2) {
        text-align: center;
        border-top: 1px solid #FF9F0E;
        border-left: 1px solid #FF9F0E;
        width: 50%;
        padding: 20px 12px 40% 12px;
        margin: 0;
        background: #FFFEF6 url('~@/assets/mgm/decoration-sm.svg') no-repeat 0% 100% / contain;

        @include media-breakpoint-up(lg) {
          padding: 20px 12px 110px 12px;
          background: #FFFEF6 url('~@/assets/mgm/decoration.svg') no-repeat 0% 100% / contain;
        }
      }
    }
  }
}

.orange-color {
  color: #EA9921;
  font-weight: 700;
}

.activeDescription {
  list-style: none;
}

.activeDescription {
  list-style: none;
  margin: 0;
  padding: 0;

  h3,
  h4,
  h5 {
    margin: 0;
    padding: 0;
    line-height: 1.5;
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  h3 {
    font-size: 20px;
    font-weight: 900;
  }

  h4 {
    font-size: 16px;
    font-weight: 700;
    text-indent: 0.25rem;
  }
}

.activeDescription-item {
  position: relative;
  margin: 0;
  padding-left: 24px;
  font-size: 14px;

  &::after {
    content: attr(data-count);
    position: absolute;
    display: inline-block;
    left: 0.25rem;
    top: 0;
  }
}

// for 這次周年慶
.anniversary_2023_text {
  &.close {
    display: none;
  }
}

.original {
  &.close {
    display: none;
  }
}

.text-scroll {
  color: #216DDB;
}

.curpointer {
  cursor: pointer;
}

.anniversary2023Active-table {
  margin-bottom: 40px;
  position: relative;

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  &::after,
  &::before {
    content: '';
    position: absolute;
    top: 0%;
    // transform: translateY(-90%);
  }

  &::before {
    background: url('../../../assets/anniversary_2023/twoActive/balloon-left-sm.svg') no-repeat center / contain;
    width: 123px;
    height: 140px;
    left: 0;
    transform: translate(-28%, -90%);

    @include media-breakpoint-up(lg) {
      transform: translate(0%, -90%);
    }
  }

  &::after {
    background: url('../../../assets/anniversary_2023/twoActive/balloon-right-sm.svg') no-repeat center / contain;
    width: 123px;
    height: 140px;
    right: 0;
    transform: translate(28%, -90%);

    @include media-breakpoint-up(lg) {
      transform: translate(0%, -90%);
    }
  }
}

.anniversary2023Active-table {
  border-radius: 4px;
  border: 1px solid #B9B9B9;
  text-align: center;

  li {
    padding: 10px 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #373737;
  }

  p {
    font-size: 14px;
    color: #373737;
  }
}

.anniversary2023Active-tableHader {
  display: flex;

  li:first-child {
    width: 120px;
    background: #E0DED2;
    border-right: 1px solid #B9B9B9;
    border-bottom: 1px solid #B9B9B9;
  }

  li:last-child {
    background: #216DDB;
    color: #fff;
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #B9B9B9;
  }
}

.anniversary2023Active-day {
  display: flex;

  li:first-child {
    width: 120px;
    border-right: 1px solid #B9B9B9;
    border-bottom: 1px solid #B9B9B9;
  }

  li:last-child {
    flex-grow: 1;
    border-bottom: 1px solid #B9B9B9;
  }
}

.anniversary2023Active-target {
  display: flex;

  li:first-child {
    flex-shrink: 0;
    width: 120px;
    border-right: 1px solid #B9B9B9;
    border-bottom: 1px solid #B9B9B9;
  }

  li:last-child {
    flex-grow: 1;
    border-bottom: 1px solid #B9B9B9;
  }
}

.anniversary2023Active-machine {
  display: flex;

  li:first-child {
    flex-shrink: 0;
    width: 120px;
  }

  li:last-child {
    flex-grow: 1;
    display: block;
    padding: 0;

    p {
      padding: 10px 12px;
      margin: 0;
    }

    p:nth-child(1) {
      border-left: 1px solid #B9B9B9;
    }

    p:nth-child(2),
    p:nth-child(3) {
      border-top: 1px solid #B9B9B9;
      border-left: 1px solid #B9B9B9;
    }

    p:last-child {
      border-top: 1px solid #216DDB;
      border-left: 1px solid #216DDB;
    }

    p:nth-child(odd) {
      background: #D5EEFC;
    }

    p:last-child {
      background: #F3F9FF;
      padding: 20px 12px;
      position: relative;

      span {
        display: block;
        font-weight: 700;
        color: #333;
        text-align: center;
        margin-bottom: 20px;
      }

      .text-scroll {
        display: inline;
        font-weight: 400;
        color: #216DDB;
      }

      img {
        display: none;

        @include media-breakpoint-up(lg) {
          display: block;
          position: absolute;
          right: 10px;
          bottom: 0;
        }
      }
    }
  }
}
.google-mgm.anniversary2023Active-tableHader {
  display: flex;

  li:first-child {
    display: none;
    @include media-breakpoint-up(lg) {
      display: flex;
    }
    width: 120px;
    background: #E0DED2;
    border-right: 1px solid #B9B9B9;
    border-bottom: 1px solid #B9B9B9;
  }
  li:nth-child(2) {
    background: #216DDB;
    color: #fff;
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #B9B9B9;
    border-right: 1px solid #B9B9B9;
    width: calc(50% - 60px);
  }
  li:nth-child(3) {
    width: calc(50% - 60px);
    background: #0042A3;
    color: #fff;
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #B9B9B9;
  }
}
.google-mgm.anniversary2023Active-target {
  display: flex;

  li:first-child {
    display: none;
    @include media-breakpoint-up(lg) {
      display: flex;
      flex-shrink: 0;
      width: 120px;
      border-right: 1px solid #B9B9B9;
      border-bottom: 1px solid #B9B9B9;
    }
  }

  li:nth-child(2) {
    width: 50%;
    @include media-breakpoint-up(lg) {
      width: calc(50% - 60px);
    }
    display: block;
    border-right: 1px solid #B9B9B9;
    border-bottom: 1px solid #B9B9B9;
    .text-scroll {
      display: inline;
      font-weight: 700;
      margin: 0 4px;
    }
  }

  li:last-child {
    width: 50%;
    @include media-breakpoint-up(lg) {
      width: calc(50% - 60px);
    }
    display: block;
    flex-grow: 1;
    border-bottom: 1px solid #B9B9B9;
  }
}
.google-mgm.anniversary2023Active-machine {
  display: block;
  @include media-breakpoint-up(lg) {
    display: flex;
  }

  li:first-child {
    flex-shrink: 0;
    text-align: center;
    width: 100%;
    border-bottom: 1px solid #B9B9B9;
    @include media-breakpoint-up(lg) {
      width: 120px;
      margin: 0;
    }
  }

  li:last-child {
    flex-grow: 1;
    display: block;
    padding: 0;

    p {
      padding: 10px 12px;
      margin: 0;
    }

    p:nth-child(1) {
      border-left: none;
      border-right: 1px solid #B9B9B9;
      @include media-breakpoint-up(lg) {
        border-left: 1px solid #B9B9B9;
        border-right: none;
      }
    }

    p:nth-child(2),
    p:nth-child(3) {
      border-top: 1px solid #B9B9B9;
      border-left: none;
      @include media-breakpoint-up(lg) {
        border-left: 1px solid #B9B9B9;
      }
    }
    p:nth-child(odd) {
      background: #D5EEFC;
    }
    .award-Details {
      p:nth-child(1) {
        border-top: 1px solid #B9B9B9;
        background: #F3F9FF;
        span {
          display: block;
          font-weight: 700;
          color: #333;
          text-align: center;
        }
        span.text-scroll {
          display: inline;
          font-weight: 700;
          color: #216DDB;
        }
      }
      p:nth-child(2) {
        background: #fff;
        padding: 20px 12px 100px 12px;
        position: relative;

        span {
          display: block;
          font-weight: 700;
          color: #333;
          text-align: center;
          margin-bottom: 20px;
        }

        .text-scroll {
          display: inline;
          font-weight: 400;
          color: #216DDB;
        }

        img {
          display: none;

          @include media-breakpoint-up(lg) {
            display: block;
            position: absolute;
            right: 10px;
            bottom: 0;
          }
        }
      }
    }
  }
}
.award-Details {
  display: flex;
  p {
    width: 50%;
  }
}
</style>
